module.exports = __webpack_public_path__ + "static/media/settings_gear_selected.90109ee8.svg";